(function ($, Drupal) {

  Drupal.behaviors.defenderGallery = {
    attach: function (context) {
      var gallery = $(".paragraph--type--gallery");
      var galleryEquipment = $(".view-id-equipment_block");

      function generateObjectForSlick(that) {
        return {
          dots: false,
          infinite: true,
          speed: 500,
          fade: true,
          cssEase: 'linear',
          prevArrow: that.children('.gallery-controls__left'),
          nextArrow: that.children('.gallery-controls__right'),
          centerPadding: 0,
          adaptiveHeight: false
        }
      }

      gallery.each(function() {
        var params = generateObjectForSlick($(this));
        $(this).children('.gallery--inner').slick(params);
      });

      galleryEquipment.each(function() {
        var params = generateObjectForSlick($(this));
        $(this).children('.view-content').slick(params);
      });

    }
  }

})(jQuery, Drupal);
